import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const badgeVariants = cva(
	'inline-flex items-center gap-1 rounded px-2 py-0.5 text-[11px] font-medium',
	{
		variants: {
			tone: {
				green: 'badge-pill tone-green',
				amber: 'badge-pill tone-amber',
				red: 'badge-pill tone-red',
				blue: 'badge-pill tone-blue',
				violet: 'badge-pill tone-violet',
				gray: 'badge-pill tone-gray'
			}
		},
		defaultVariants: {
			tone: 'gray'
		}
	}
);

export interface BadgeProps
	extends React.HTMLAttributes<HTMLSpanElement>,
		VariantProps<typeof badgeVariants> {
	noDot?: boolean;
}

function Badge({ className, tone, noDot, children, ...props }: BadgeProps) {
	const dotClass = noDot ? 'no-dot' : '';
	return (
		<span className={cn(badgeVariants({ tone }), dotClass, className)} {...props}>
			{children}
		</span>
	);
}

export { Badge, badgeVariants };
